import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { CouponPointsModel } from '../model/index';

@Injectable()
export class CouponPointsService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    });
    private couponPointsUrl = 'api/couponPoints';

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getCouponPointsList(query: any): Promise<CouponPointsModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.couponPointsUrl}/couponPointsList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    deleteCouponPoints(cp_id: any): Promise<CouponPointsModel> {
        const url = `${this.couponPointsUrl}/deleteCouponPoints`;
        return this.http
            .post(url, $.param({ cp_id: cp_id }), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CouponPointsModel)
            .catch(this.handleError);
    }

    addUpdateCouponPoints(couponPointsData: any): Promise<CouponPointsModel> {
        const url = `${this.couponPointsUrl}/addUpdateCouponPoints`;

        return this.http
            .post(url, $.param(couponPointsData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as CouponPointsModel)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/couponPoints.service.ts